import '../scss/shop-detail.scss';

import baguetteBox from 'baguettebox.js';
import 'bootstrap/js/dist/collapse';

import isVisible from "../components/isVisible";

import '../page-interactive';
import { makeResponsive } from "../components/responsitive";
import sendData from '../components/sendData';


baguetteBox.run('.gallery');
makeResponsive();



function ToggleBuyButtons(descriptionBlock, buttonsBlock){
  const descriptionBlockIsVisible = isVisible(descriptionBlock);
  const hasClass = buttonsBlock.classList.contains('fixed');
  buttonsBlock.style.width = descriptionBlock.offsetWidth + 'px';
  if (descriptionBlockIsVisible && descriptionBlockIsVisible === 'whole'){
    if (!hasClass) buttonsBlock.classList.add('fixed');
  } else {
    if (hasClass) buttonsBlock.classList.remove('fixed');
  }
}

document.addEventListener("DOMContentLoaded", function(event) {
  const textField = document.getElementById('id_text');
  if (textField){
    if (window.location.hash.indexOf('#add_comment') !== -1) textField.focus();
    document.querySelector('.create-response').addEventListener('click',(event) => { textField.focus(); });
  }

  const moreLessonsLink = document.getElementById('show-more-lessons');
  if (moreLessonsLink){
    moreLessonsLink.addEventListener('click', function(event){
      event.preventDefault();
        document.getElementById('more-lessons-block').classList.remove('d-none');
        moreLessonsLink.parentNode.removeChild(moreLessonsLink);
    });
  }

  const descriptionWrapper = document.querySelector(".detail-description-wrapper");
  const beforeDescriptionButtons = document.querySelector(".detail-before-description-buttons");

  if (descriptionWrapper && beforeDescriptionButtons){
    ToggleBuyButtons(
      descriptionWrapper,
      beforeDescriptionButtons,
    );

    window.addEventListener('scroll', function() {
      ToggleBuyButtons(
        descriptionWrapper,
        beforeDescriptionButtons,
      );
    });
  }

  // редактирование описаний файлов для автора и сотрудников
  const editFilesLinks = document.querySelectorAll('.edit-files-description');
  if (editFilesLinks.length){
    editFilesLinks.forEach(link => {
      link.addEventListener('click', function(event){
        event.preventDefault();
        const parent = this.closest('.files-item');
        parent.querySelector('.files-item__data').classList.add('d-none');
        parent.querySelector('.files-item__form').classList.remove('d-none');
        return false;
      });
    });

    document.querySelectorAll('.files-item__form .btn-secondary').forEach(btn => {
      btn.addEventListener('click', function(event){
        const parent = this.closest('.files-item');
        parent.querySelector('.files-item__data').classList.remove('d-none');
        parent.querySelector('.files-item__form').classList.add('d-none');
        return false;
      });
    });

    document.querySelectorAll('.files-item__form').forEach(form => {
      form.addEventListener('submit', function(event){
        event.preventDefault();
        sendData('PUT', this.getAttribute('action'), new FormData(form))
          .then((data) => {
            const parent = this.closest('.files-item');
            let note = data.note ? data.note : gettext('Добавить описание');
            parent.querySelector('.edit-files-description').innerHTML = `(${note})`;
            parent.querySelector('.files-item__data').classList.remove('d-none');
            parent.querySelector('.files-item__form').classList.add('d-none');
        });
        return false;
      });
    });
  }

  const pswpGallery = document.querySelector('.pswp')
  if (pswpGallery){
    pswpGallery.addEventListener('contextmenu', e => {
      e.preventDefault();
    });
  }
});

